// 用户相关API接口
import request from '@/utils/request'
// 向外按需导出一个API函数
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

/**
 * 获取用户(自身)信息
 * @returns {*}
 */
export function getInfo() {
  return request({
    url: '/user',
    method: 'get',
  })
}

/**
 * 获取其他用户信息
 * @param uid
 */
export function getInfoElse(uid) {
  return request({
    url: '/user/'+uid,
    method: 'get',
  })
}

/**
 * 退出登录
 * @returns {*}
 */
export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}

/**
 * 修改密码接口
 * @param data
 * @returns {*}
 */
export function updatepwd(data) {
  return request({
    url: '/user/reset/old',
    method: 'post',
    data
  })
}

/**
 * 更新用户信息（本身）
 * @param data
 * @returns {*}
 */
export function updateUserSelf(data) {
  return request({
    url: '/user/self',
    method: 'put',
    data
  })
}

/**
 * 更新用户信息
 * @param data
 * @returns {*}
 */
export function updateUser(data) {
  return request({
    url: '/user',
    method: 'put',
    data
  })
}
/**
 * 获取用户菜单 tag=0用户菜单
 * tag=1项目菜单
 * @param param
 * @returns {*}
 */
export function getMenu(params) {
  return request({
    url: '/user/menu',
    method: 'get',
    params
  })
}
/**
 分页获取用户信息
 */
export function userList(params,data){
  return request({
    url: '/user/page',
    method: 'post',
    params,
    data
  })
}

/**
 * 添加用户接口
 * @param data
 * @returns {*}
 */
export function userAdd(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}

/**
 * 上传用户自身头像
 * @param data
 * @returns {*}
 */
export function updateHeadImgSelf( data ) {
  return request({
    url: '/user/self/avatar',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 根据手机号或者用户名查询用户是否存在
 * @param param
 * @returns {*}
 */
export function userExist( params ) {
  return request({
    url: '/exist',
    method: 'get',
    params/*,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }*/
  })
}

/***
 * 替换手机号
 * @param data
 * @returns {*}
 */
export function updateMobile(data) {
  return request({
    url: '/user/self/phone',
    method: 'put',
    data
  })
}

/**
 * 根据uid销毁用户
 * @param uid
 * @returns {*}
 */
export function delUser(uid) {
  return request({
    url: '/user/destroy/'+ uid,
    method: 'delete'
  })
}

/**
 * 返回指定用户的数据范围
 * @param uid
 * @returns {*}
 */
export function getScope( uid ) {
  return request({
    url: '/user/scope/'+uid,
    method: 'get'
  })
}

/**
 * 返回登录用户的数据范围
 * @returns {*}
 */
export function getScopeLogin() {
  return request({
    url: '/user/login/scope',
    method: 'get'
  })
}

/**
 *
 * @param data
 * @returns {*}
 */
export function addScope(data,uid) {
  return request({
    url: '/user/scope/'+uid,
    method: 'post',
    data
  })
}

/**
 * 返回用户设备关联的小区信息，第一个为用户设备最近安装的小区
 * @param mobile
 * @returns {*}
 */
export function getCommunitiesByMobile(mobile) {
  return request({
    url: '/user/communities/'+mobile,
    method: 'get'
  })
}
/**
 * 返回用户权限代码列表
 * @param mobile
 * @returns {*}
 */
export function getCodeList() {
  return request({
    url: '/user/code/list',
    method: 'get'
  })
}

/**
 * 获取不同产品分类下用户数
 * @returns {*}
 */
export function getCountByCategory() {
  return request({
    url: '/user/category/count',
    method: 'get'
  })
}
